import {
  RECEIVE_GRANTS,
  RECEIVE_MEMBER_TYPES,
  REQUEST_MEMBERS,
  RECEIVE_MEMBERS,
  RECEIVE_TENANT_USERS,
  CREATE_MEMBER_SUCCESS,
  RECEIVE_INVITATIONS,
  DELETE_INVITATION_SUCCESS,
  CHECKED_INVITATIONS,
  REQUEST_SERVICE_ACCOUNTS,
  RECEIVE_SERVICE_ACCOUNTS,
  TRANSFER_SERVICE_ACCOUNTS,
} from './actions';
import { CLEAR_SITE_DATA } from '../application';

const initialState = {
  grants: undefined,
  loadingMembers: true,
  loadingTenantUsers: true,
  loadingInvitations: true,
  loadingServiceAccounts: true,
  transferringServiceAccounts: false,
  checkedInvitations: null,
  members: [],
  memberTypes: [],
  tenantUsers: {},
  invitations: [],
  serviceAccounts: [],
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_GRANTS: {
      return { ...state, grants: action.grants };
    }
    case RECEIVE_MEMBER_TYPES: {
      return { ...state, memberTypes: action.memberTypes };
    }
    case REQUEST_MEMBERS: {
      return {
        ...state,
        loadingMembers: true,
        loadingTenantUsers: !!action.indexUsers,
      };
    }
    case CREATE_MEMBER_SUCCESS:
    case RECEIVE_MEMBERS:
      return {
        ...state,
        members: action.members,
        loadingMembers: false,
      };
    case RECEIVE_TENANT_USERS: {
      return {
        ...state,
        tenantUsers: action.tenantUsers,
        loadingTenantUsers: false,
      };
    }
    case RECEIVE_INVITATIONS: {
      return {
        ...state,
        invitations: action.invitations,
        loadingInvitations: false,
      };
    }
    case DELETE_INVITATION_SUCCESS: {
      const inviteIndex = state.invitations.findIndex((i) => i.id === action.invitationId);
      return {
        ...state,
        invitations: [
          ...state.invitations.slice(0, inviteIndex),
          ...state.invitations.slice(inviteIndex + 1),
        ],
      };
    }

    case CHECKED_INVITATIONS: {
      return {
        ...state,
        checkedInvitations: action.checkedInvitations,
      };
    }

    case REQUEST_SERVICE_ACCOUNTS: {
      return {
        ...state,
        loadingServiceAccounts: true,
      };
    }

    case TRANSFER_SERVICE_ACCOUNTS: {
      return {
        ...state,
        transferringServiceAccounts: true,
      };
    }

    case RECEIVE_SERVICE_ACCOUNTS: {
      return {
        ...state,
        serviceAccounts: action.serviceAccounts,
        loadingServiceAccounts: false,
        transferringServiceAccounts: false,
      };
    }

    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        loadingMembers: true,
        loadingTenantUsers: true,
        loadingInvitations: true,
        loadingServiceAccounts: true,
        transferringServiceAccounts: false,
        checkedInvitations: null,
        members: [],
        memberTypes: [],
        tenantUsers: {},
        invitations: [],
        serviceAccounts: [],
      };
    }
    default:
      return state;
  }
}

export default reducer;
